import _ from 'lodash'
let msisdnToPhone = (msisdn) => {
    msisdn += ""; // TURNS IT INTO A STRING
    let regExp = /(\d{3})(\d{3})(\d{4})$/;
    let conform = msisdn.match(regExp)
    return '(' + conform[1] + ') ' + conform[2] + '-' + conform[3];
}
let mb2gb = mbNumber => {
    return ( mbNumber / 1024 ).toFixed(2) + ' GB'
}
let altanFixLabel = str => {
    let matrix = [
        {str: 'Best Effort', replace: 'Mejor disponible'},
        {str: /subscriber[ ]does[ ]not[ ]exist/, replace: 'El número no está con Skycel®'},
    ];
    let foundIndex = _.findIndex(matrix, item => {
        return (
            (_.isRegExp(item.str) && item.str.test(_.trim(str))) 
            || (item.str == _.trim(str))
        )
    })
    if(foundIndex != -1){
        return matrix[foundIndex].replace
    } else {
        return str
    }
}
export {
    msisdnToPhone, 
    altanFixLabel,
    mb2gb
}